import api from '../../services/pipelineSubmitted';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('pipelines_submitted');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'Submitted Pipelines');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}